import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

const BUGSNAG_ENABLED = import.meta.env.VITE_BUGSNAG_ENABLED === "true";
const BUGSNAG_API_KEY = import.meta.env.VITE_BUGSNAG_API_KEY || "FAKE API KEY";
const BUGSNAG_ENVIRONMENT = import.meta.env.VITE_BUGSNAG_ENVIRONMENT;

Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginReact()],
  onError: function(event) {
    if (!BUGSNAG_ENABLED) {
      return false;
    }
    event.app.releaseStage = BUGSNAG_ENVIRONMENT;
  }
});

export default Bugsnag;